var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EargoButton } from '@/components/eargo-button.component';
import { Link, Typography } from '@mui/material';
import { imagePersonLookingAtPhone } from 'hx-assets';
import { useNavigate } from 'react-router-dom';
export var LandingPage = function () {
    var navigate = useNavigate();
    return (_jsxs("div", __assign({ className: "grid md:grid-cols-[auto_1fr] gap-4 p-4" }, { children: [_jsx("img", { src: imagePersonLookingAtPhone, alt: "" }), _jsxs("div", __assign({ className: "grid gap-4 p-4 align-start" }, { children: [_jsx(Typography, __assign({ sx: {
                            color: 'primary.main',
                            fontWeight: 'bold !important',
                            fontSize: '24px !important',
                            textAlign: 'left',
                            marginInline: 0,
                        } }, { children: "Remote Support from Product Experts" })), _jsx(Typography, __assign({ sx: {
                            fontSize: '16px',
                            textAlign: 'left',
                            marginInline: 0,
                        } }, { children: "Speak with Product Experts to find the model and fit best suited to your lifestyle" })), _jsxs(Typography, __assign({ sx: {
                            fontSize: '16px',
                            textAlign: 'left',
                            marginInline: 0,
                        } }, { children: ["Call ", _jsx(Link, __assign({ href: "tel:7992127607" }, { children: "(799) 212 7607" })), " Monday to Saturday from 9am to 8pm EST."] })), _jsx(EargoButton, __assign({ variant: "contained", onClick: function () { return navigate('/speak-to-an-expert-form'); }, sx: {
                            borderRadius: '0px',
                            marginRight: 'auto',
                        } }, { children: "Speak to a product expert" }))] }))] })));
};
